export default "__VITE_ASSET__Dhmxjrj0__"